import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';
import servicesVisualBreak from '../assets/services-visual-break.png';

const Services = () => {
    // SVG Icons
    const TenantRelationsIcon = () => (
        <svg className="service-page-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <path d="M32 16C36.4183 16 40 19.5817 40 24C40 28.4183 36.4183 32 32 32C27.5817 32 24 28.4183 24 24C24 19.5817 27.5817 16 32 16Z" fill="#FFFFFF" />
            <path d="M18 48C18 40.268 24.268 34 32 34C39.732 34 46 40.268 46 48" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" />
            <path d="M48 24H56" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M8 24H16" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );

    const MaintenanceIcon = () => (
        <svg className="service-page-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <path d="M22 42L16 48L22 54L28 48L22 42Z" fill="#FFFFFF" />
            <rect x="20" y="14" width="6" height="34" rx="1" transform="rotate(-45 23 31)" fill="#D4AF37" />
            <path d="M42 22L48 16L54 22L48 28L42 22Z" fill="#FFFFFF" />
            <rect x="34" y="26" width="6" height="26" rx="1" transform="rotate(45 37 39)" fill="#D4AF37" />
            <circle cx="32" cy="32" r="5" fill="#FFFFFF" stroke="#0A192F" strokeWidth="2" />
        </svg>
    );

    const FinancialsIcon = () => (
        <svg className="service-page-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <rect x="20" y="20" width="24" height="24" rx="2" stroke="#FFFFFF" strokeWidth="2" />
            <path d="M32 16V20" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M32 44V48" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M16 32H20" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M44 32H48" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M28 28L32 32L36 24" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M26 36H38" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );

    const StrategyIcon = () => (
        <svg className="service-page-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <path d="M16 44L26 34L34 42L48 20" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M48 20H38" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
            <path d="M48 20V30" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
            <path d="M42 42V48" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M32 46V48" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M22 44V48" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <circle cx="26" cy="34" r="3" fill="#D4AF37" />
            <circle cx="34" cy="42" r="3" fill="#D4AF37" />
            <circle cx="48" cy="20" r="3" fill="#D4AF37" />
        </svg>
    );
    const services = [
        {
            icon: TenantRelationsIcon,
            title: "Tenant Relations & Retention",
            description: "We handle all tenant interactions with professionalism and care, ensuring high retention rates and satisfied residents.",
            items: [
                "Comprehensive tenant screening",
                "Lease agreement management",
                "Conflict resolution",
                "24/7 emergency response",
                "Move-in/Move-out inspections"
            ]
        },
        {
            icon: MaintenanceIcon,
            title: "Maintenance & Operations",
            description: "Proactive maintenance to preserve your property's value and keep systems running efficiently.",
            items: [
                "Regular property inspections",
                "Preventative maintenance planning",
                "Vendor management and supervision",
                "Emergency repair coordination",
                "Capital improvement oversight"
            ]
        },
        {
            icon: FinancialsIcon,
            title: "Financial Management",
            description: "Transparent financial reporting to keep you informed about your investment's performance.",
            items: [
                "Rent collection and disbursement",
                "Monthly financial statements",
                "Expense management",
                "Budgeting and forecasting",
                "Year-end tax document preparation"
            ]
        },
        {
            icon: StrategyIcon,
            title: "Strategic Planning",
            description: "Long-term strategies to maximize the value and return on your real estate investment.",
            items: [
                "Market analysis and rent maximization",
                "Asset value enhancement strategies",
                "Regulatory compliance",
                "Investment performance reviews"
            ]
        }
    ];

    return (
        <div className="services-page">
            <div className="page-header">
                <div className="container">
                    <h1>Our Management Services</h1>
                    <p>Comprehensive solutions for your residential property investment.</p>
                </div>
            </div>

            <div className="container section">
                <div className="services-intro text-center">
                    <p className="lead">
                        P&C Property Management offers a full suite of services designed to take the burden off owners
                        while maximizing the value of their assets. We bring over 20 years of experience to every property we manage.
                    </p>
                </div>

                {/* Visual Break Placeholder */}
                <div className="visual-break-placeholder">
                    <img src={servicesVisualBreak} alt="Property Management Team" className="visual-break-image" />
                </div>

                <div className="services-list">
                    {services.map((service, index) => (
                        <div key={index} className="service-item">
                            <div className="service-content">
                                <service.icon />
                                <h2>{service.title}</h2>
                                <p>{service.description}</p>
                                <ul className="service-features">
                                    {service.items.map((item, idx) => (
                                        <li key={idx}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="cta-section text-center">
                    <h3>Ready to elevate your property management?</h3>
                    <p>Contact us today for a consultation.</p>
                    <Link to="/contact" className="btn-primary">Get in Touch</Link>
                </div>
            </div>
        </div>
    );
};

export default Services;
